module.exports = __webpack_public_path__ + "static/media/FP-bg.9189bacc.png";